<template>
	<div class="finance-index-main">
		<el-row>
			<div class="finance-index-top-main">
				<div class="finance-index-top-title">账户资产概况</div>
				<div class="finance-index-info-view">
					<div class="finance-index-info-one">
						<p class="finance-index-info-tit">销售金额
							<el-tooltip class="item" effect="dark" content="订单实际到账金额-退款金额" placement="top-start">
								<el-button style="border: 0;padding: 0;"><i class="el-icon-question"
										style="color: #CCCCCC;"></i></el-button>
							</el-tooltip>
						</p>
						<p class="finance-index-info-uumber-val">{{info.sell_money}}<span class="finance-index-info-yuan">
								元</span></p>
					</div>
					<div class="finance-index-info-one">
						<p class="finance-index-info-tit">推广佣金
							<el-tooltip class="item" effect="dark" content="指合伙人佣金支出总和" placement="top-start">
								<el-button style="border: 0;padding: 0;"><i class="el-icon-question"
										style="color: #CCCCCC;"></i></el-button>
							</el-tooltip>
						</p>
						<p class="finance-index-info-uumber-val">{{info.total_commission}}<span class="finance-index-info-yuan">
								元</span></p>
					</div>
					<div class="finance-index-info-one">
						<p class="finance-index-info-tit">服务费
							<el-tooltip class="item" effect="dark" content="指平台的服务费支出总和" placement="top-start">
								<el-button style="border: 0;padding: 0;"><i class="el-icon-question"
										style="color: #CCCCCC;"></i></el-button>
							</el-tooltip>
						</p>
						<p class="finance-index-info-uumber-val">{{info.total_tax}}<span class="finance-index-info-yuan">
								元</span></p>
					</div>
					<div class="finance-index-info-one" style="border-right:none;">
						<p class="finance-index-info-tit">保证金
							<el-tooltip class="item" effect="dark" placement="top-start">
								<div slot="content">保证金收取：采取就高原则，取所申请的类目保证金最大值<br/>保证金余额 = 实缴保证金 - 违规处罚扣除</div>
								<el-button style="border: 0;padding: 0;">
									<i class="el-icon-question" style="color: #CCCCCC;"></i>
								</el-button>
							</el-tooltip>
						</p>
						<p class="finance-index-info-uumber-val">{{info.total_ensure}}<span class="finance-index-info-yuan"> 元</span></p>
					</div>
				</div>
			</div>
		</el-row>
		<el-row>
			<div class="finance-index-list-main">
				
			<div class="finance-index-list-top-view">
				<div class="finance-index-list-top-title">收支概况</div>
				<div class="finance-index-list-tab-view">
					<div @click="changeTab(0)" class="finance-index-list-tab-one" :class="tab==0?'finance-index-list-tab-act':''">今日</div>
					<div @click="changeTab(1)" class="finance-index-list-tab-one" :class="tab==1?'finance-index-list-tab-act':''">昨日</div>
				</div>
				<div class="finance-index-list-lookall" @click="goBillList()">查看全部<i
						class="el-icon-arrow-right"></i></div>
			</div>
			<el-table v-loading="loading" :data="tableData" style="width: 100%;">
				<el-table-column prop="create_time" label="时间" width="100" align="center">
				</el-table-column>
				<el-table-column label="业务类型" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.business_type == 1">商品</span>
						<span v-else-if="scope.row.business_type == 2">活动</span>
					</template>
				</el-table-column>
				<el-table-column prop="order_sn" label="业务单号" width="250" align="center">
				</el-table-column>
				<el-table-column label="收支类型" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.category == 1">产品订单</span>
						<span v-else-if="scope.row.category == 2">平台服务费</span>
						<span v-else-if="scope.row.category == 3">推广佣金</span>
					</template>
				</el-table-column>
				<el-table-column label="收入/支出" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 1">收入</span>
						<span v-else>支出</span>
					</template>
				</el-table-column>
				<el-table-column label="金额(元)" align="center">
					<template slot-scope="scope">
						<span v-if="" :class="scope.row.change_amount >0?'finance-index-list-money-add':'finance-index-list-money-cut'">{{scope.row.change_amount}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: center;margin-top: 35px;padding-bottom: 35px;" v-if="total == 0">
				<img src="../../assets/img/finance/in_out.png" style="width: 126px;height: 140px;" />
				<p class="nohhr">没有发现更多的数据了～</p>
			</div>
			<!-- 分页器 -->
			<div v-if="tableData.length>0" class="block" style="padding: 40px;background: #ffffff;">
				<el-pagination background align='center' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
				</el-pagination>
			</div>
			</div>
		</el-row>
	</div>
</template>

<script>
	import {
		getAccountData,
		getAccountLog
	} from '../../api/finance';
	export default {
		data() {
			return {
				tab: 0, // 0今日 1昨日
				info:{},//账户数据
				tableData: [], //列表数据
				currentPage: 0, // 当前页码
				total: -1, // 总条数
				pageSize: 5, // 每页的数据条数
				loading: true,
			};
		},
		created() {
			this.currentPage = 0;
			this.getData();
			this.getList();
		},
		methods: {
			goBillList(){
				this.$router.push({
					path: '/finance/bill_list',
				});
			},
			formatNumber(value) {
				let isW = value >= 10000 ? true : false;
				return isW ? Math.floor((value / 10000) * 10) / 10 + 'w' : value;
			},
			getData(){
				getAccountData({}).then(res => {
					if (res.code == 0) {
						this.info = res.data;
					} else {
						this.$message.error(res.message);
					}
					
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			changeTab(tab){
				if(this.tab == tab){
					return false;
				}
				this.tab = tab;
				this.total = -1;
				this.currentPage = 0;
				this.tableData = [];
				this.getList();
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			getList() {
				this.loading = true;
				let currentPage = this.currentPage;
				let tab = this.tab;
				let count = this.pageSize;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getAccountLog({
					'tab':tab,
					'start': currentPage * count,
					'count': count
				}).then(res => {
					if (res.code == 0) {
						this.total = res.data.count;
						this.loading = false;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}
	
				})
			},
			
		}
	};
</script>

<style scoped="scoped">
	.finance-index-top-main{
		background: #fff;
		margin-bottom: 16px;
	}
	.finance-index-list-main>>>.el-table__empty-block{
		display: none;
	}
	.finance-index-list-main{
		background: #fff;
	}
	.finance-index-top-title{
		height: 55px;
		line-height: 55px;
		margin-left: 16px;
		font-size: 16px;
		font-weight: 500;
		color: #333333;
	}
	.finance-index-info-view{
		display: flex;
		border-top: 1px solid #EEEEEE;
		border-bottom: 1px solid #EEEEEE;
	}
	.finance-index-info-one{
		flex: 1;
		border-right: 1px solid #EEEEEE;
		padding-bottom: 40px;
	}
	.finance-index-operate-info{
		display: flex;
		padding-bottom: 40px;
	}
	.finance-index-recharge-btn{
		width: 102px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		margin-left: 35px;
		margin-top: 68px;
	}
	
	.finance-index-list-top-view{
		display: flex;
	}
	.finance-index-list-top-title{
		margin: 16px 19px 2px 16px;
		font-size: 16px;
		font-weight: 500;
		color: #333333;
	}
	.finance-index-list-tab-view{
		background: #0486FE;
		display: flex;
		width: 98px;
		height: 20px;
		border-radius: 2px;
		border: 1px solid #0486FE;
		margin-top: 18px;
		margin-left: 19px;
	}
	.finance-index-list-tab-one{
		flex: 1;
		font-size: 14px;
		font-weight: 500;
		color: #0486FE;
		line-height: 20px;
		background: #fff;
		text-align: center;
		cursor: pointer;
	}
	.finance-index-list-tab-act{
		background: #0486FE;
		color: #fff;
	}
	.finance-index-list-lookall{
		color: #0486FE;
		cursor: pointer;
		margin-left: auto;
		margin-right: 16px;
		margin-top: 19px;
		font-size: 12px;
	}
	.finance-index-list-money-add{
		color: #67C23A;
	}
	.finance-index-list-money-cut{
		color: #000000;
	}
	.finance-index-info-tit{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		margin:40px 0 6px 50px;
	}
	.finance-index-info-uumber-val{
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
		margin-left:50px;
	}
	.finance-index-info-yuan{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		margin-top: 11px;
		margin-bottom: 40px;
	}
	
	.nohhr {
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
	}
</style>
